<template>
  <!--  simply copied and pasted an existing cabinet-settings-drawer element and made slight changes to have an cabinet-settings-drawer button that doesn't expand-->
  <div :class="{ 'dx-state-disabled': disabled, 'active-nav': activeNav }"
       class="dx-item dx-accordion-item dx-accordion-item-closed"
       role="tab"
       aria-selected="false"
       style="transition: none 0s ease 0s; height: 42.4333px;"
       @click="clickMethod"
  >
    <div class="dx-item-content dx-accordion-item-title custom-accordion-button">
      <div class="dx-accordion-item-title-caption">
        {{ title }}
      </div>
      <div v-if="icon">
        <i :class="`dx-icon-${icon} custom-icon`"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from "vue";
  import router from "@/router/index.js";

  const props = defineProps(['title', 'icon', 'onClick', 'disabled', 'route', 'routeParams'])

  const activeNav = computed(() => props.route ? props.route.name === props.route : false) //for improvement: migrate to a store

  const clickMethod = () => {
    if (props.onClick)
      props.onClick()
    else if (props.route)
      goToRoute(props.route)
  }
  const goToRoute = (route) => {
    if (!activeNav.value)
      router.push({name: route})
  }
</script>

<style scoped lang="scss">
  .dx-accordion-item {
    transition: border-left 100ms, color 100ms !important;
    margin: 0;
  }

  .dx-accordion-item.dx-state-disabled {
    color: #bdbdbd; // color taken by inspecting real disabled DxAccordion items
  }

  .custom-accordion-button {
    display: flex;

    .dx-accordion-item-title-caption {
      flex-grow: 1;
    }

    .custom-icon {
      font-size: 18px;
    }
  }

  .dx-accordion-item-title::before {
    content: unset;
  }

  .dx-accordion-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .active-nav {
    border-left: 5px solid $blue-500;
    font-weight: bold;
    background-color: transparent !important;

    .dx-accordion-item-title {
      color: $la-primary !important;
    }
  }
</style>
